import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import OutputLayoutColumn from '../elements/OutputLayoutColumn'

import Sidebar from '../elements/Sidebar'
import Controller from '../elements/Controller'
import OutputColumn from '../elements/OutputColumn'
import Button from '../elements/Button'
import OutputHeader from '../elements/OutputHeader'
import OutputFilter from '../elements/OutputFilter'
import OutputBarChart from '../elements/OutputBarChart'
import OutputTable from '../elements/OutputTable'

import ModalManager from '../elements/ModalManager'

import Dropdown from '../elements/ReactSelectDropdown'

import FiltersModal from '../assets/metrics/FiltersModal'

import { useCookies } from 'react-cookie'

import MonthlySheetsExport from '../assets/metrics/MonthlySheetsExport'

import ViewSaturdayReport from '../assets/metrics/ViewSaturdayReport'

import CalendarModal from '../assets/metrics/CalendarModal'

import WeekSelector from '../elements/WeekSelector'

import ReserveAccountLedger from '../assets/metrics/ViewReserveLedger'
import Notification from '../elements/Notification'
import IconButton from '../elements/IconButton'
import Edit from '../media/icons/icons8-edit-96.png'
import EditWeekBonus from '../assets/monthlySheets/EditWeekBonus'
import EditWeekPaySystemCustom from '../assets/monthlySheets/EditWeekPaySystemCustom'
import EditWeekNotes from '../assets/monthlySheets/EditWeekNotes'

import WeekSettings from '../assets/monthlySheets/WeekSettings'

const Main = (props) => {

    const list = ['Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski', 'Jon Bukowski']

    const [cookies, setCookies] = useCookies([])

    const [weekBonusModal, setWeekBonusModal] = useState(false)
    const [weekNotesModal, setWeekNotesModal] = useState(false)
    const [selectedWeekNum, setSelectedWeekNum] = useState(-1)
    const [paySystem, setPaySystem] = useState([{label: 'Default', value: 'default'},{label: 'Default', value: 'default'},{label: 'Default', value: 'default'},{label: 'Default', value: 'default'},{label: 'Default', value: 'default'}])
    const [customRateModal, setCustomRateModal] = useState(false)

    const [notification, setNotification] = useState('')

    const [headerValues, setHeaderValues] = useState([])
    const [allAgents, setAllAgents] = useState([])
    const [selectedAgent, setSelectedAgent] = useState({value: '', label: 'All Agents'})
    const [selectedReport, setSelectedReport] = useState('')
    const [specificAgent, setSpecificAgent] = useState({id: '659742ce7c605a59716c4553', role: 'subagent'})
    const [agentNumber, setAgentNumber] = useState(0)
    const [skip, setSkip] = useState(0)

    const [refresh, setRefresh] = useState(false)

    const [filtersModal, setFiltersModal] = useState(false)
    const [sort, setSort] = useState('timestamp')

        function formatNumber(value) {
                try {
                        const num = parseFloat(value);
                        if (!isNaN(num)) {
                                return new Intl.NumberFormat('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                }).format(num);
                        }
                        // If value is not numeric, return it unchanged
                        return value;
                } catch (e) {
                        return value;
                }
        }

    const formatDateFilters = (date) => {
        if (!(date instanceof Date)) {
            return '';
        }
    
        let day = date.getDate();
        let month = date.getMonth() + 1; // getMonth() returns 0-11
        let year = date.getFullYear().toString(); // Get last two digits
    
        // Pad single digit month and day with a zero
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
    
        return `${year}-${month}-${day}`;
    }

    function getRecentTuesdayAndUpcomingMonday() {
        const today = new Date();
        const recentTuesday = new Date(today);
        const upcomingMonday = new Date(today);
    
        // Adjust recentTuesday to the most recent Tuesday or today if today is Tuesday
        while (recentTuesday.getDay() !== 2) {
            recentTuesday.setDate(recentTuesday.getDate() - 1);
        }
    
        // Adjust upcomingMonday to the next Monday if today is not Monday, or today if today is Monday
        while (upcomingMonday.getDay() !== 1) {
            upcomingMonday.setDate(upcomingMonday.getDate() + 1);
        }
    
        const formatDate = (date) => {
            return date.getFullYear().toString() + '-' +
                   (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
                   date.getDate().toString().padStart(2, '0');
        };
    
        return [formatDate(upcomingMonday), formatDate(recentTuesday)];
    }
    

    const [calStartDate, setCalStartDate] = useState(getRecentTuesdayAndUpcomingMonday()[1])
    const [calEndDate, setCalEndDate] = useState(getRecentTuesdayAndUpcomingMonday()[0])

    const transposeArray = (array) => {
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    };

    const countDuplicateSubarrays = (arrayOfArrays) => {
        const arrayMap = new Map();
      
        arrayOfArrays.forEach(subArray => {
          // Convert each subarray to a string to use as a unique key for comparison
          const key = JSON.stringify(subArray);
          if (arrayMap.has(key)) {
            arrayMap.set(key, arrayMap.get(key) + 1);
          } else {
            arrayMap.set(key, 1);
          }
        });
      
        // Convert the map back into an array of arrays with quantities
        return Array.from(arrayMap, ([key, value]) => [JSON.parse(key), value]);
    }

    function formatDate(date) {
        if (!(date instanceof Date)) {
            throw new Error('Input must be a Date object');
        }
    
        let day = date.getDate();
        let month = date.getMonth() + 1; // getMonth() returns 0-11
        let year = date.getFullYear().toString().substr(-2); // Get last two digits
    
        // Pad single digit month and day with a zero
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
    
        return `${month}/${day}/${year}`;
    }

    const masterList = [
        {
            name: 'Export Report',
            link: '',
            onClick: () => {setExportDataModal(true)},
        },
        ...props.masterList
    ]

    const [totalAgents, setTotalAgents] = useState(5000)

    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        let requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }

        props.tokenSafeAPIRequest('/metrics/metadata/CombinedSubagentReport/visible', requestOptions, '', (result) => {
            console.log(result)
            setTotalAgents(result.length-1)
        })
    },[])

    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + cookies['access_token']);

        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
        };

        props.tokenSafeAPIRequest('/permission/me', requestOptions, '', (result, status) => {
            console.log(result) //'*':'*' - Superadmin
            let tempButtonList = [{
                name: 'Export Report',
                link: '',
                onClick: () => {setExportDataModal(true)},
            }]
            if (result.static_role === 'superadmin' || result.static_role === 'admin')
            {
                localStorage.setItem('button_list', JSON.stringify(masterList))
                setButtonList(masterList)
            }
            else
            {
                result.allow.Metrics.map((metric) => {
                    masterList.map((button) => {
                        if (metric === button.key)
                        {
                            tempButtonList.push(button)
                        }
                    })
                })
                tempButtonList = tempButtonList.sort((a,b) => {
                    if (a.name === "Export Report") return -1; // Move "Export Report" to the top
                    if (b.name === "Export Report") return 1;
                    return a.name.localeCompare(b.name);
                })
                localStorage.setItem('button_list', JSON.stringify(tempButtonList))
                setButtonList(tempButtonList)
            }
        })  
    },[])

    const [exportDataModal, setExportDataModal] = useState(false)
    const [buttonList, setButtonList] = useState(JSON.parse(localStorage.getItem('button_list')))

    //Summary Table

    const [summaryTitles, setSummaryTitles] = useState([
        {
            title: 'Col 1',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Col 2',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Col 3',
            displayElement: (props) => (props.index === 3 ? 
                <div style={{display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center'}}>
                    <span style={{marginLeft: '60px', marginRight: '30px', whiteSpace: 'nowrap'}}>${formatNumber(props.data)}</span>
                    <IconButton onClick={() => {setWeekBonusModal(true); setSelectedWeekNum(props.tableIndex)}} Style={{backgroundColor: props.colors.primary}} size={31} image={Edit} colors={props.colors}></IconButton>
                </div>    
                :        
                <span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>${formatNumber(props.data)}</span>),
            default: '',
        },
        {
            title: 'Col 4',
            displayElement: (props) => (props.index === 0 ? 
                <div style={{display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center'}}>
                    <span style={{marginLeft: '60px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>
                    <IconButton onClick={() => {setWeekNotesModal(true); setSelectedWeekNum(props.tableIndex)}} Style={{backgroundColor: props.colors.primary}} size={31} image={Edit} colors={props.colors}></IconButton>
                </div>    
                :        
                <span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
    ])

    const [summaryValues, setSummaryValues] = useState([
        [summaryTitles[0].default], 
        [summaryTitles[1].default],
        [summaryTitles[2].default],
        [summaryTitles[3].default], 
    ])
    // Array of per-week tables (each is tableData with same column layout as summaryValues)
    const [weeklySummaryTables, setWeeklySummaryTables] = useState([])

    //End Summary Table

    const handleLedgerOpen = (data) => {
        if (data.reserveInputs.length > 0)
        {
            setSelectedLedger(data.reportCode)
            setViewLedger(true)
        }
        else
        {

        }
    }

    const [viewLedger, setViewLedger] = useState(false)
    const [selectedLegder, setSelectedLedger] = useState(-1)

    const [rowSelected, setRowSelected] = useState([false])

    const onTableChange = (e,x,y) => {
        console.log(e,x,y)
    }

    useEffect(() => {
        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json")
            
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                month: calStartDate.slice(0, 7),
            })
        }

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + (specificAgent.role === 'subagent' ? 'agent':'mgmt') + '/' + specificAgent.id + '?fetch_links=true', requestOptions, '', (result, status) => {
            console.log(result)
            setSelectedAgent(result)

            if (!result.weeks || result.weeks.length === 0)
            {
                setSummaryValues([
                    [summaryTitles[0].default], 
                    [summaryTitles[1].default],
                    [summaryTitles[2].default],
                    [summaryTitles[3].default], 
                ])
                setWeeklySummaryTables([])
                setNotification(result.detail ? (getCurrentTimeFormatted() + ' - ' + result.detail):getCurrentTimeFormatted() + ' - Error! Please try again!')
            }
            else
            {
                const tables = []
                const tempPaySystem = []
                result.weeks.forEach((week) => {
                    const t = Array.from({ length: result.weeks.length }, () => []);

                    t[0].push(week.week_label)
                    t[1].push('-')
                    t[2].push('-')
                    t[3].push('Notes')

                    t[0].push('Weekly Net')
                    t[1].push('Paid')
                    t[2].push(week?.paid_amount)
                    t[3].push(week?.paid_amount_notes)

                    const adminString = Array.isArray(week?.contract_count_by_admin)
                        ? week.contract_count_by_admin.map(admin => `${admin.code}-${admin.count.toFixed(2)}`).join(' , ')
                        : ''
                    t[0].push(adminString)
                    t[1].push('Bring Month To Paid')
                    t[2].push(week?.bmt_paid_amount)
                    t[3].push(week?.bmt_notes)

                    t[0].push('-')
                    t[1].push('Bonuses Paid')
                    t[2].push(week?.bonuses_paid_amount)
                    t[3].push(week?.bonuses_paid_notes)

                    tables.push(t)

                    tempPaySystem.push({label: week.payment_system === 'Custom' ? week.payment_system + ' - ' + (week.custom_rate*100) + '%':week.payment_system, value: week.payment_system})
                })

                // keep the old summaryValues for compatibility, but set weekly tables
                console.log(tables.length ? tables[0] : [])
                console.log(tables)
                setSummaryValues(tables.length ? tables[0] : [])
                setWeeklySummaryTables(tables)
                setPaySystem(tempPaySystem)
            }
        })
    },[agentNumber, specificAgent, calStartDate, calEndDate, refresh])

    useEffect(() => {
        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({})
        }

        let tempSubagentList = []

        props.tokenSafeAPIRequest('/user/search?limit=99999', requestOptions, '', (result) => {
            console.log(result)
            result.map((subagent, index) => {
                tempSubagentList.push({value: {id: subagent.id, role: subagent.role}, label: subagent.name})
            })
            setAllAgents(tempSubagentList)
        })
    },[])

    const handleAgentChange = (change) => {
        setSpecificAgent(-1)
        let tempNum = agentNumber + change;
        console.log(tempNum)
        if (tempNum < 0)
        {
            setAgentNumber(totalAgents)
        }
        else if (tempNum > totalAgents)
        {
            setAgentNumber(0)
        }
        else
        {
            setAgentNumber(tempNum)
        }
    }

    const generateKey = () => {
        let tempNum = Math.random() * 100000
        return (Math.round(tempNum) + 'F') ;
    }

    const viewFullReport = (table, index, tableData) => {
        let reportCode = transposeArray(tableData)[index][9]

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        let requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }

        props.tokenSafeAPIRequest('/report/full/' + reportCode + '?completed_only=true', requestOptions, '', (result) => {
            console.log(result)
            setSelectedReport(result)
            setViewSatReport(true)
        })
    }

    const [viewSatReport, setViewSatReport] = useState(false)

    const exportKeys = [{id: 'quantity', label: 'Dealer'}, {id: 'admin_ID.name', label: 'Admin'}, {id: 'dealership_ID.name', label: 'Dealership'}, {id: 'report_type', label: 'Report Type'}, {id: 'contract_type', label: 'Contract Type'}, {id: 'timestamp', label: 'Date'}, {id: 'contract_gross', label: 'Gross'}, {id: 'net', label: 'Net'}]

    const buildFilterData = () => {
        return {
            subagent_ID: specificAgent
        }
    }

    function formatDateString(dateString) {
        // Parse the date string into a Date object
        const date = new Date(dateString);
    
        // Options for toLocaleDateString to format the date as 'Month Day, Year'
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
    
        // Format the date
        return date.toLocaleDateString('en-US', options);
    }

    const [selectDatesModal, setSelectDatesModal] = useState(false)

    const filterDate = (start, end) => {
        if (start.getTime() > end.getTime())
        {
            
        }
        else
        {
            start = formatDateFilters(start)
            end = formatDateFilters(end)
            setCalStartDate(start)
            setCalEndDate(start)
        }
    }

    function getCurrentTimeFormatted() {
        const now = new Date();
  
        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'
        
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
      
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    }

    const recalculateValues = () => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({month: '2026-03'}),
            redirect: 'follow',
        };

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/compile', requestOptions, '', (result, status) => {
            console.log(result)
            if (status === 200)
            {
                setNotification('Recalculated Values Successfully: ' + getCurrentTimeFormatted())
                setRefresh((refresh) => !refresh)
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const editWeekBonus = (weekNum, bonusAmount) => {

        console.log(bonusAmount)

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify({bonuses_paid_amount: Number(bonusAmount)}),
            redirect: 'follow',
        };

        let sheetID = selectedAgent.id; //weird nanming, but its the sheet ID for the agent

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + sheetID + '/week/' + weekNum, requestOptions, '', (result, status) => {
            console.log(result)
            if (status === 200)
            {
                setNotification('Edited Week Bonus Successfully: ' + getCurrentTimeFormatted())
                setRefresh((refresh) => !refresh)
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const editWeekNotes = (weekNum, paidNotes, BMTNotes, bonusesNotes) => {

        console.log(paidNotes)
        console.log(BMTNotes)
        console.log(bonusesNotes)

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify({
                paid_amount_notes: paidNotes,
                bmt_notes: BMTNotes,
                bonuses_paid_notes: bonusesNotes,
            }),
            redirect: 'follow',
        };

        let sheetID = selectedAgent.id; //weird nanming, but its the sheet ID for the agent

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + sheetID + '/week/' + weekNum, requestOptions, '', (result, status) => {
            console.log(result)
            if (status === 200)
            {
                setNotification('Edited Week Notes Successfully: ' + getCurrentTimeFormatted())
                setRefresh((refresh) => !refresh)
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const reviewedWeek = (week) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify({
                reviewed: !selectedAgent.weeks[week].reviewed
            }),
            redirect: 'follow',
        };

        let sheetID = selectedAgent.id; //weird naming, but its the sheet ID for the agent

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + sheetID + '/week/' + week, requestOptions, '', (result, status) => {
            console.log(result)
            if (status === 200)
            {
                setNotification('Edited Reviewed Status Successfully: ' + getCurrentTimeFormatted())
                setRefresh((refresh) => !refresh)
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const updatePaySystem = (week, newValue) => {
        console.log(newValue)
        
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify({
                payment_system: newValue.value,
            }),
            redirect: 'follow',
        };

        if (newValue.amount !== undefined)
        {
            requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify({
                payment_system: newValue.value,
                custom_rate: newValue.amount/100
            }),
            redirect: 'follow',
        };
        }

        let sheetID = selectedAgent.id; //weird naming, but its the sheet ID for the agent

        props.tokenSafeAPIRequest('/metrics/monthly_sheet/' + sheetID + '/week/' + week, requestOptions, '', (result, status) => {
            console.log(result)
            if (status === 200)
            {
                setNotification('Edited Pay System Successfully: ' + getCurrentTimeFormatted())
                setSelectedAgent((prev) => ({
                    ...prev,
                    weeks: prev.weeks.map((weekItem, index) => index === week ? {...weekItem, payment_system: newValue} : weekItem)
                }))
                setRefresh((refresh) => !refresh)
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const handlePaySystemChange = (week, selectedOption, validated) => {
        console.log(selectedOption)
        if (selectedOption.value === 'Custom' && validated !== true)
        {
            setSelectedWeekNum(week)
            setCustomRateModal(true)
        }
        else
        {

            // setPaySystem((prev) => prev.map((entry, index) => index === week ? {label: newLabel, value: newValue} : entry))
            updatePaySystem(week, selectedOption)
        }
    }

    let options = [
        {value: 'Default', label: 'Default'},
        {value: 'Draw', label: 'Draw'},
        {value: 'Starter Deal', label: 'Starter Deal'},
        {value: 'Custom', label: 'Custom'}
    ]
    
    return (
        <OutputLayoutColumn colors={props.colors}>
            <Sidebar colors={props.colors} tab={1}></Sidebar>
            <Controller colors={props.colors} tokenSafeAPIRequest={props.tokenSafeAPIRequest} activeButton={true} buttonList={buttonList} title={"Outputs"}></Controller>
            <div></div>{/* <OutputColumn colors={props.colors} list={list} title={"Subagents"}></OutputColumn> */}
            <div> {/*THERE IS A HIDDEN STYLE TAG FROM THE OUTPUT LAYOUT --- width: "auto", marginLeft: '20px', display: 'flex', flexDirection: 'column'*/}
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <div style={{backgroundColor: props.colors.block, border: '1px solid' + props.colors.border, padding: '5px 10px 5px 10px', borderRadius: '3px', fontWeight: '500'}}>
                        <span>{selectedAgent?.name} - {selectedAgent?.month_label} | {selectedAgent?.weeks?.[0].week_friday} - {selectedAgent?.weeks?.[4].week_friday} | Last Compiled: {formatDateString(selectedAgent?.last_compiled)}</span>
                    </div>
                    <WeekSelector colors={props.colors} onClick={() => setSelectDatesModal(true)} active={true} calStartDate={calStartDate} calEndDate={calStartDate} Style={{marginLeft: 'auto', marginRight: '20px'}}>{calStartDate === '2000-01-01' ? '':calStartDate + ' | '} Select Week | {calEndDate === '2200-01-01' ? 'All Times':calEndDate}</WeekSelector>
                    {localStorage.getItem('role') === 'subagent' ? '':<div style={{backgroundColor: props.colors.block, display: 'flex', flexDirection: 'row', marginRight: '50px', alignItems: 'center', border: '1px solid ' + props.colors.border, borderRadius: '5px'}}>
                        <span className='noSelect' onClick={() => handleAgentChange(-1)} style={{fontWeight: '800', marginLeft: '10px', cursor: 'pointer'}}>{'<'}</span>
                        <Dropdown colors={props.colors} Style={{border: 'none'}} onChange={(e) => setSpecificAgent(e.value)} value={selectedAgent?.name} data={allAgents}></Dropdown>
                        <span className='noSelect' onClick={() => handleAgentChange(1)} style={{fontWeight: '800', marginRight: '10px', cursor: 'pointer'}}>{'>'}</span>
                    </div>}
                </div>
                {localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'superadmin' ? <Button colors={props.colors} onClick={() => recalculateValues()} Style={{width: '200px', backgroundColor: props.colors.primary, color: props.colors.fontInvert, marginTop: '10px'}}>Recalculate Values</Button>:''}
                <div style={{flexGrow: 2, overflowY: 'auto'}}>
                    {weeklySummaryTables.length === 0 ? (
                        <OutputTable colors={props.colors} includeHeader={false} index={0} tableData={summaryValues} tableInfo={summaryTitles} rows={rowSelected} setRows={setRowSelected} onChange={onTableChange} selectMenu={false} onBottom={() => console.log('')}></OutputTable>
                    ) : (
                        weeklySummaryTables.map((tableData, i) => (
                            <div key={i} style={{marginTop: '10px'}}>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: 'min-content'}}>
                                    {localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'superadmin' ?                 
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            <span>Pay System</span>
                                            <Dropdown colors={props.colors} onChange={(e) => handlePaySystemChange(i, e)} data={options} width={195} value={paySystem[i]?.label ?? 'Default'}></Dropdown>
                                        </div>:''}
                                    {localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'superadmin' ? <div onClick={() => reviewedWeek(i)} style={{marginTop: '20px', marginLeft: '10px', cursor: 'pointer', width: '22px', height: '22px', border: selectedAgent.weeks[i].reviewed ? '2px solid ' + props.colors.primary:'2px solid ' + props.colors.border, borderRadius: '5px', backgroundColor: selectedAgent.weeks[i].reviewed  ? props.colors.primary:''}}></div>:''}
                                    {localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'superadmin' ? <span onClick={() => reviewedWeek(i)} style={{marginLeft: '10px', fontWeight: '500', marginTop: '20px'}}>Reviewed?</span>:''}
                                </div>
                                <OutputTable colors={props.colors} index={i} includeHeader={false} tableData={tableData} tableInfo={summaryTitles} rows={rowSelected} setRows={setRowSelected} onChange={onTableChange} selectMenu={false} onBottom={() => console.log('')}></OutputTable>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <ModalManager colors={props.colors}>
                <MonthlySheetsExport colors={props.colors} agents={allAgents} isOpen={exportDataModal} setIsOpen={() => setExportDataModal(false)} url={'/metrics/dealership'} tokenSafeAPIRequest={props.tokenSafeAPIRequest} exportKeys={exportKeys} fileTitle={'Combined Subagent Report'} reportData={weeklySummaryTables} admin_report_info={selectedAgent.admin_report_info} specificAgent={specificAgent} calStartDate={calStartDate} calEndDate={calEndDate} sort={sort} selectedAgent={selectedAgent}></MonthlySheetsExport>
                <CalendarModal colors={props.colors} isOpen={selectDatesModal} calStartDate={calStartDate} calEndDate={calStartDate} setIsOpen={() => setSelectDatesModal(false)} filterDate={filterDate}></CalendarModal>
                <EditWeekPaySystemCustom colors={props.colors} selectedWeekNum={selectedWeekNum} handlePaySystemChange={handlePaySystemChange} isOpen={customRateModal} setIsOpen={() => setCustomRateModal(false)}></EditWeekPaySystemCustom>
                <EditWeekBonus colors={props.colors} selectedWeekNum={selectedWeekNum} editWeekBonus={editWeekBonus} isOpen={weekBonusModal} setIsOpen={() => setWeekBonusModal(false)}></EditWeekBonus>
                <EditWeekNotes colors={props.colors} selectedWeekNum={selectedWeekNum} existingNotes={selectedWeekNum === -1 ? {paidNotes: '', BMTNotes: '', bonusesNotes: ''}:{paidNotes: selectedAgent.weeks[selectedWeekNum].paid_amount_notes, BMTNotes: selectedAgent.weeks[selectedWeekNum].bmt_notes, bonusesNotes: selectedAgent.weeks[selectedWeekNum].bonuses_paid_notes}} editWeekNotes={editWeekNotes} weekLength={weeklySummaryTables} isOpen={weekNotesModal} setIsOpen={() => setWeekNotesModal(false)}></EditWeekNotes>
            </ModalManager>
            <Notification colors={props.colors} message={notification}></Notification>
        </OutputLayoutColumn>
    )
}

export default Main
